import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import './assets/css/reset.css';
import axios from 'axios';
import { defaultFunc } from './assets/js/http-func';
import http from './utils/http/request';
import moment from 'moment';
Vue.prototype.$http = http;
Vue.config.productionTip = false;
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;
http.setDefaults({
    timeout: 6000,
    ...defaultFunc
});
axios.defaults.withCredentials = true;
Vue.prototype.ajax = axios;
new Vue({
    router,
    render: (h) => h(App)
}).$mount('#app');
